export enum ProtectYourAccountResponses {
  DEFAULT,
  ACTIVATE,
}
